<script setup>
import { Head, usePage } from '@inertiajs/vue3';
import Card from 'primevue/card';
import AuthenticatedAdminLayout from '@/Layouts/AuthenticatedAdminLayout.vue';

const page = usePage();

const totalOrderable = page.props.total_orderable;
const totalPending = page.props.total_pending;
const totalInvoiced = page.props.total_invoiced;
const totalRefunded = page.props.total_refunded;

const currencyFormatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
</script>

<template>
  <AuthenticatedAdminLayout>
    <Head title="Statistiques"/>

    <main class="relative p-4 sm:px-6 lg:px-8 flex flex-col justify-center sm:items-center mx-auto size-full">
      <div class="flex flex-row justify-between items-center pb-4 size-full">
        <h1 class="text-xl sm:text-2xl text-primary uppercase font-semibold">
          Statistiques
        </h1>
      </div>

      <div class="my-4 flex flex-row flex-wrap justify-start gap-8">
        <Card>
          <template #title>
            Total commandable (quota)
          </template>
          <template #content>
            {{ currencyFormatter.format(totalOrderable) }}
          </template>
        </Card>

        <Card>
          <template #title>
            Total en attente
          </template>
          <template #content>
            {{ currencyFormatter.format(totalPending) }}
          </template>
        </Card>

        <Card>
          <template #title>
            Total facturé
          </template>
          <template #content>
            {{ currencyFormatter.format(totalInvoiced) }}
          </template>
        </Card>

        <Card>
          <template #title>
            Total remboursé
          </template>
          <template #content>
            {{ currencyFormatter.format(totalRefunded) }}
          </template>
        </Card>

        <Card>
          <template #title>
            Total facturé - remboursé
          </template>
          <template #content>
            {{ currencyFormatter.format(totalInvoiced - totalRefunded) }}
          </template>
        </Card>
      </div>
    </main>
  </AuthenticatedAdminLayout>
</template>